import { useState } from "react";
import { PrimaryButton } from "../../components/primary-button/primary-button";
import * as S from "./mobile-content.styles";
import { icons } from "./constants";
import { MobileMenu } from "./components/menu/menu";
import { Logo } from "../../../../components/logo/logo";
import { useCart } from "../../../../hooks/use-cart-hook";

export const MobileContent = () => {
  const { openCart } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const iconsWithActions = icons.map((icon) => {
    if (icon.icon.iconName === "bars") {
      return { ...icon, onClick: () => setMenuOpen(true) };
    }

    if (icon.icon.iconName === "cart-shopping") {
      return { ...icon, onClick: openCart };
    }

    return icon;
  });

  return (
    <>
      <S.RowWrapper>
        <Logo />
        <S.ListWrapper>
          {iconsWithActions.map((icon, index) => (
            <PrimaryButton {...icon} key={index} />
          ))}
        </S.ListWrapper>
      </S.RowWrapper>

      <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
};
